import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react';
import { ExcelIcon } from '@assets/icons/index';
import { formatFileSize } from '@helpers/utils';
import { PDFIcon, UploadIcon2 } from '@assets/icons';
import React from 'react';

const FilePreview = ({ accessFile = {}, isLoading = false, onClick = () => {} }) => {
    let Icon = accessFile?.type === 'application/pdf' ? PDFIcon : ExcelIcon;
    return (
        <Flex
            bg={'semantic.200'}
            textAlign="center"
            borderRadius="8px"
            p={'12px 16px'}
            cursor={!isLoading ? 'pointer' : 'default'}
            justifyContent={'space-between'}
            gap={'12px'}
        >
            <HStack gap={'8px'}>
                <Icon />
                <Box textAlign={'left'}>
                    <Text
                        fontSize={'14px'}
                        fontWeight={700}
                        color={isLoading ? '#7A7A7A' : '#2A3D4A'}
                        mb={'4px'}
                        noOfLines={1}
                    >
                        {accessFile?.name}
                    </Text>
                    <Text color={'#7A7A7A'} fontSize={'14px'}>
                        {formatFileSize(accessFile?.size)}
                    </Text>
                </Box>
            </HStack>

            <Button variant={'text'} colorScheme="sagitarius" onClick={onClick} disabled={isLoading}>
                Ganti File
                <Box>
                    <UploadIcon2 size={15} />
                </Box>
            </Button>
        </Flex>
    );
};

export default FilePreview;
